import React from 'react'

import prevport from "../../../../Assets/images/projects/prevportdetailed.png"
import ProjectInfo from '../ProjectInfo'

export default function Prevport() {
    return (
        <ProjectInfo
            pic={prevport}
            title="Previous Portfolio Website"
            maincolor="#2a37b4"
            accentcolor="#1586cc"
            link="https://jrwolf1.netlify.app/"
            githublink="https://github.com/Jrwolf99/Jrwolf-Portfolio"
        >
            <p>This website is my previous portfolio. Check out some older projects here, as well as the website itself!</p>
            <br />
            <p>This website was developed using vanilla HTML5, CSS, and JavaScript. </p>
            <br />



        </ProjectInfo>
    )
}
